import React from 'react';
import { DatePicker } from 'antd';

export default function DtPicker(props) {
    return <DatePicker format={!props.showTime ? 'DD/MM/YYYY' : 'DD/MM/YYYY HH:mm:ss'} allowClear={false} {...props} style={{ maxWidth: 140, ...props.style }} />
}